import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getFeedbackText, getSzansa, toDateLocal } from '../rozmowaDetailsHelpers'

export default function useRozmowaDetailsEdit(rozmowa, onSaveFields) {
	const { t } = useTranslation()
	const [editing, setEditing] = useState(true)
	const [noteValue, setNoteValue] = useState('')
	const [nextConversationValue, setNextConversationValue] = useState('')
	const [salesOpportunityValue, setSalesOpportunityValue] = useState(false)
	const [fieldsReady, setFieldsReady] = useState(false)
	const [saving, setSaving] = useState(false)
	const [saveError, setSaveError] = useState(null)

	const noteText = getFeedbackText(rozmowa)
	const nextConversationText = toDateLocal(rozmowa?.dig_nastepnej_rozmowy)
	const salesOpportunity = getSzansa(rozmowa)

	if (!editing) {
		if (fieldsReady) setFieldsReady(false)
		if (noteValue !== noteText) setNoteValue(noteText)
		if (nextConversationValue !== nextConversationText) setNextConversationValue(nextConversationText)
		if (salesOpportunityValue !== salesOpportunity) setSalesOpportunityValue(salesOpportunity)
	} else if (rozmowa && !fieldsReady) {
		setFieldsReady(true)
		if (noteValue !== noteText) setNoteValue(noteText)
		if (nextConversationValue !== nextConversationText) setNextConversationValue(nextConversationText)
		if (salesOpportunityValue !== salesOpportunity) setSalesOpportunityValue(salesOpportunity)
	}

	const handleStartEdit = () => {
		setSaveError(null)
		setNoteValue(noteText)
		setNextConversationValue(nextConversationText)
		setSalesOpportunityValue(salesOpportunity)
		setEditing(true)
	}

	const handleCancelEdit = () => {
		setSaveError(null)
		setNoteValue(noteText)
		setNextConversationValue(nextConversationText)
		setSalesOpportunityValue(salesOpportunity)
		setEditing(false)
	}

	const handleSave = async () => {
		if (!onSaveFields) return

		if (!nextConversationValue) {
			setSaveError(t('conversations.details.messages.nextConversationRequired'))
			return
		}

		setSaving(true)
		setSaveError(null)

		try {
			await onSaveFields({
				feedback: noteValue,
				dig_nastepnej_rozmowy: nextConversationValue,
				szansa: salesOpportunityValue,
			})
			setEditing(false)
		} catch (error) {
			setSaveError(error.message || t('conversations.messages.updateFailed'))
		} finally {
			setSaving(false)
		}
	}

	return {
		editing,
		noteValue,
		nextConversationValue,
		saving,
		saveError,
		handleStartEdit,
		handleCancelEdit,
		handleSave,
		setNoteValue,
		setNextConversationValue,
		salesOpportunityValue,
		setSalesOpportunityValue,
	}
}
